import { useState } from "react";
import { adminApi } from "@/lib/api";
import { useNavigate, Link } from "react-router-dom";
import { TID } from "@/lib/constants";
import { toast } from "sonner";
import DistillMark from "@/components/DistillMark";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      // Server sets an HttpOnly `distill_admin_session` cookie on success —
      // there is nothing for the client to store. This eliminates the XSS
      // token-theft surface entirely.
      await adminApi.login(email.trim(), password);
      toast.success("Signed in.");
      navigate("/studio", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#111622] flex items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-[420px] rounded-2xl bg-[#1A2232] border border-[#26334D] p-6 shadow-[0_10px_30px_rgba(15,23,42,0.06)]">
        <div className="flex items-center gap-3">
          <DistillMark size={36} />
          <div className="flex flex-col leading-none">
            <span className="text-base font-semibold tracking-[0.22em] text-[#E85A2A]">DISTILL</span>
            <span className="mt-1 text-[10px] font-semibold text-[#94A3B8] tracking-wide">No BS, only GS.</span>
          </div>
        </div>
        <h1 className="mt-5 text-lg font-semibold text-[#F8FAFC]">Admin console</h1>
        <p className="mt-1 text-xs text-[#94A3B8]" style={{ lineHeight: 1.6 }}>For content editors only.</p>

        <label className="mt-4 block text-xs font-semibold tracking-wide text-[#94A3B8] uppercase">Email</label>
        <input
          data-testid={TID.adminEmail}
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          autoComplete="username"
          required
          autoFocus
          className="mt-1 h-11 w-full rounded-xl border border-[#26334D] bg-[#111622] px-3 text-sm text-[#F8FAFC] placeholder-[#64748B] focus:outline-none focus:ring-2 focus:ring-[#E85A2A]"
        />

        <label className="mt-3 block text-xs font-semibold tracking-wide text-[#94A3B8] uppercase">Password</label>
        <input
          data-testid={TID.adminPassword}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="mt-1 h-11 w-full rounded-xl border border-[#26334D] bg-[#1A2232] px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#E85A2A]"
        />

        <button
          data-testid={TID.adminSubmit}
          disabled={busy}
          type="submit"
          className="mt-5 w-full rounded-xl bg-[#E85A2A] text-[#F8FAFC] py-3 text-sm font-semibold hover:bg-[#C94A1D] transition-colors disabled:opacity-50"
        >{busy ? "Signing in…" : "Sign in"}</button>

        <Link to="/" className="mt-4 block text-center text-xs text-[#94A3B8] hover:text-[#E85A2A] transition-colors">← Back to app</Link>
      </form>
    </div>
  );
}
